import { colorCoreWhite1000 } from '@yme/tokens/colors';
export const DISCOVER_NEW_DESK_COLUMNS = 9;
const DISCOVER_NEW_DATA_TEST_ID = 'Home_Discover-new';
export const DISCOVER_NEW_CONTAINER_PROPS = {
    dataTestId: DISCOVER_NEW_DATA_TEST_ID,
    bgColor: colorCoreWhite1000,
    pt: '24px',
    pb: '24px',
    mdPt: '24px',
    mdPb: '24px',
    lgPt: '48px',
    lgPb: '48px',
};
